import { GlButton } from '@gitlab/ui';
import { translate, sprintf } from '../../../../utils/i18n';
import { formatLocalizedDate } from '../../../../utils/date';
import DuoChatThreadsEmpty from './duo_chat_threads_empty';
import __vue_normalize__ from 'vue-runtime-helpers/dist/normalize-component.js';

const i18n = {
  CHAT_HISTORY_INFO: translate('DuoChat.chatHistoryInfo', 'Inactive chats are deleted after 30 days.'),
  THREAD_DELETE_LABEL: translate('DuoChat.threadDeleteLabel', 'Delete this thread.'),
  OPEN_CHAT_LABEL: translate('DuoChat.openChatLabel', 'Open chat: %{title}')
};
var script = {
  name: 'DuoChatHistory',
  components: {
    GlButton,
    DuoChatThreadsEmpty
  },
  props: {
    threads: {
      type: Array,
      required: true
    },
    preferredLocale: {
      type: Array,
      required: true
    }
  },
  computed: {
    formattedLocalDate() {
      return date => formatLocalizedDate(date, this.preferredLocale);
    },
    groupedThreads() {
      if (!this.hasThreads) {
        return {};
      }
      return this.threads.slice().sort((a, b) => this.compareThreadDates(b.lastUpdatedAt, a.lastUpdatedAt)).reduce((grouped, thread) => {
        const dateKey = this.getDateKey(thread.lastUpdatedAt);
        return {
          ...grouped,
          [dateKey]: [...(grouped[dateKey] || []), thread]
        };
      }, {});
    },
    hasThreads() {
      return this.threads.length > 0;
    }
  },
  methods: {
    onNewChat() {
      this.$emit('new-chat');
    },
    onSelectThread(thread) {
      this.$emit('select-thread', thread);
    },
    onDeleteThread(threadId, event) {
      event.stopPropagation();
      this.$emit('delete-thread', threadId);
    },
    onClose() {
      this.$emit('close');
    },
    compareThreadDates(dateA, dateB) {
      return new Date(dateA) - new Date(dateB);
    },
    getDateKey(date) {
      return new Date(date).toISOString().split('T')[0];
    },
    sprintf
  },
  i18n
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gl-p-5"},[_c('div',{staticClass:"gl-bg-gray-50 gl-text-gray-500 gl-p-4 gl-mb-5 gl-rounded-base",attrs:{"data-testid":"chat-threads-info-banner"}},[_c('p',{staticClass:"gl-m-0 gl-flex"},[_vm._v("\n      "+_vm._s(_vm.$options.i18n.CHAT_HISTORY_INFO)+"\n    ")])]),_vm._v(" "),(_vm.hasThreads)?_vm._l((_vm.groupedThreads),function(threadsForDate,date){return _c('div',{key:date},[_c('div',{staticClass:"gl-font-bold gl-neutral-900 gl-my-4",attrs:{"data-testid":"chat-threads-date-header"}},[_vm._v("\n        "+_vm._s(_vm.formattedLocalDate(date))+"\n      ")]),_vm._v(" "),_c('div',_vm._l((threadsForDate),function(thread){return _c('div',{key:thread.id,staticClass:"gl-flex gl-align-center"},[_c('gl-button',{staticClass:"hover:gl-bg-gray-50 gl-text-ellipsis !gl-text-default justify-content-start gl-overflow-hidden gl-rounded-base gl-rounded-base gl-p-4 gl-w-full gl-whitespace-nowrap",attrs:{"data-testid":"chat-threads-thread-box","category":"tertiary","aria-label":_vm.sprintf(_vm.$options.i18n.OPEN_CHAT_LABEL, { title: thread.title || 'Untitled Chat' })},on:{"click":function($event){return _vm.onSelectThread(thread)}}},[_vm._v("\n            "+_vm._s(thread.title || 'Untitled Chat')+"\n          ")]),_vm._v(" "),_c('gl-button',{staticClass:"gl-neutral-900 !gl-p-4",attrs:{"data-testid":"chat-threads-delete-thread-button","icon":"remove","category":"tertiary","size":"small","aria-label":_vm.$options.i18n.THREAD_DELETE_LABEL},on:{"click":function($event){return _vm.$emit('delete-thread', thread.id)}}})],1)}),0)])}):_c('duo-chat-threads-empty')],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = __vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
